import { resetAllTips } from './nuxTips'

const TIP_PREFIX = 'beacon_tip_'

function tipEntries(storage: Storage): Record<string, string | null> {
  const out: Record<string, string | null> = {}
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i)
    if (key?.startsWith(TIP_PREFIX)) out[key.slice(TIP_PREFIX.length)] = storage.getItem(key)
  }
  return out
}

/**
 * Console helpers for poking at app state by hand — `Debug.resetTips()` in
 * devtools (or Safari's Web Inspector on a device). Installed in every build:
 * nothing here reaches beyond this browser's own storage.
 */
const Debug = {
  /** Every coachmark shows again, as if on a fresh install. Same as Settings → Reset tips. */
  resetTips() {
    resetAllTips()
    return 'Tips reset'
  },
  /** What each tip has recorded: `local` survives restarts, `session` is this tab only. */
  tips() {
    return { local: tipEntries(localStorage), session: tipEntries(sessionStorage) }
  },
}

declare global {
  interface Window {
    Debug: typeof Debug
  }
}

export function installDebug() {
  window.Debug = Debug
}
